module.exports = __webpack_public_path__ + "static/media/ec.8b24030f.jpeg";